import React from 'react';

import {
    withInterstitial,
} from 'wanderu-component-page-loader';
import { Redirect } from 'wanderu-component-react-router-link';

const UniversalGrid = withInterstitial(import('./containers/Grid/Grid'));
const ExplorerPage = withInterstitial(import('./pages/Explorer'), {
    onLoad(module, ...args) {
        module.onLoad(module, ...args);
    },
});

export default [
    {
        path: '/explore/:countryState?/:city?',
        component: ExplorerPage,
        key: '/explore/',
        routes: [
            {
                path: '/explore/:countryState',
                component: () => <Redirect href="/explore/" />,
                key: '/explore/:countryState',
                exact: true,
            },
            {
                path: '/explore/:countryState/:city',
                key: '/explore/:countryState/:city',
                exact: true,
                component: UniversalGrid,
            },
            {
                path: '/explore/:countryState/:city/*',
                key: '/explore/:countryState/:city-catchall',
                component: ({ match }) => {
                    const {
                        countryState,
                        city,
                    } = match.params;

                    return (
                        <Redirect href={`/explore/${countryState}/${city}/`} />
                    );
                },
            },
        ],
    },
];
